import React from "react";
import "./nudgesSkeleton.css"; // Custom CSS for the shimmer effect

function NudgesSkeleton() {
  return (
    <div className="  nudges-skeleton-card">
      {/* Image placeholder */}


      {/* Body placeholder */}


        <div style={{marginTop:"7rem"}}/>
   

        {/* Multiple text placeholders */}

        {/* Five small cards in a row */}
        <div className="nudgescomp-skeleton-row">
          {[...Array(3)].map((_, index) => (
            <div
              key={index}
              className="baseSkeleton nudges-skeleton-small-card"
            ></div>
          ))}
        </div>
        <div className="nudgescomp-skeleton-row">
          {[...Array(3)].map((_, index) => (
            <div
              key={index}
              className="baseSkeleton nudges-skeleton-small-card"
            ></div>
          ))}
        </div>
        {[...Array(3)].map((_, index) => (
          <p key={index} className="baseSkeleton nudges-skeleton-acc-bar "></p>
        ))}
      </div>
    
  );
}

export default NudgesSkeleton;
